<app-google-charts-line-chart
    [chartData]="chartDataView" 
    [chartOptions]="chartOptions">
</app-google-charts-line-chart> 
